import axios from "axios"
import { baseURL } from "../config/api"

export const getBranches = (tenantId: string) => {
    return getFetch("branch", tenantId)
}

export const getBranch = (primaryKey: string, tenantId: string) => {
    return getFetch(`branch/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}